import { ILocationItem } from '../../types/buildersLocations';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EBuildersLocationsActionType {
  SetData = 'BuildersLocations/SetData',
  StartFetching = 'BuildersLocations/StartFetching',
}

export type TBuildersLocationsActions = TSetBuildersLocationsData | TStartFetching;

export type TSetBuildersLocationsData = ITypedReduxAction<EBuildersLocationsActionType.SetData, ILocationItem[]>;

export type TStartFetching = ITypedReduxAction<EBuildersLocationsActionType.StartFetching>;
